import React, { useEffect, useMemo, useState } from 'react'
import T from 'prop-types'
import { MenuItem, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import SelectScrollable from './SelectScrollable'

const createRangeArray = (min, max, step) => {
  const options = []

  for (let i = 0; i <= max - min; i += step) {
    options.push(min + step * i)
  }
  if (options[options.length - 1] !== max) {
    options.push(max)
  }

  return options
}

const optionsMapFunction = (option) => {
  return (
    <MenuItem key={option} value={option}>
      {option}
    </MenuItem>
  )
}

export default function RangeSelect({
  minBound,
  maxBound,
  min,
  max,
  handleRangeChange,
  step = 1,
  readOnly = false,
}) {
  const { t } = useTranslation()

  const [localValue, setLocalValue] = useState([min, max])

  const options = useMemo(
    () => createRangeArray(minBound, maxBound, step),
    [minBound, maxBound, step]
  )

  useEffect(() => {
    setLocalValue([min, max])
  }, [min, max])

  const handleRangeChangeFrom = (event) => {
    setLocalValue([event.target.value, localValue[1]])
    handleRangeChange(event.target.value, localValue[1])
  }
  const handleRangeChangeTo = (event) => {
    setLocalValue([localValue[0], event.target.value])
    handleRangeChange(localValue[0], event.target.value)
  }

  return (
    <Stack direction="row" justifyContent="space-between" spacing={2}>
      <SelectScrollable
        variant="outlined"
        size="small"
        value={(localValue.length && localValue[0]) || ''}
        disabled={readOnly}
        onChange={handleRangeChangeFrom}
        displayEmpty
        sx={{ width: 1 }}
      >
        <MenuItem value="">{t('common.form.from')}</MenuItem>
        {options.map(optionsMapFunction)}
      </SelectScrollable>
      <SelectScrollable
        variant="outlined"
        size="small"
        value={(localValue.length && localValue[1]) || ''}
        disabled={readOnly}
        onChange={handleRangeChangeTo}
        displayEmpty
        sx={{ width: 1 }}
      >
        <MenuItem value="">{t('common.form.to')}</MenuItem>
        {options.map(optionsMapFunction)}
      </SelectScrollable>
    </Stack>
  )
}

RangeSelect.propTypes = {
  minBound: T.number.isRequired,
  maxBound: T.number.isRequired,
  min: T.oneOfType([T.number, T.string]).isRequired,
  max: T.oneOfType([T.number, T.string]).isRequired,
  handleRangeChange: T.func.isRequired,
  step: T.number,
}
